/** リスト内で option がはみ出していれば、見える位置まで list をスクロールする。 */
export function scrollOptionIntoView(list: HTMLElement, option: HTMLElement): void {
  // offsetTop と scrollTop はどちらもリストの padding box 上端が基準なので直接比較できる。
  const optionTop = option.offsetTop;
  const optionBottom = optionTop + option.offsetHeight;
  if (optionTop < list.scrollTop) {
    list.scrollTop = optionTop;
  } else if (optionBottom > list.scrollTop + list.clientHeight) {
    list.scrollTop = optionBottom - list.clientHeight;
  }
}
